export default __webpack_public_path__ + "static/media/3.489325f2.pdf";